import React from 'react';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';
import { getPartner } from '../../../../../../lib/access.es6';

/**
 * Summary screen showing before/after changes for member details
 */
const SummaryScreen = ({
  member,
  changes,
  policy,
  onBack,
  onConfirm
}) => {
  const currencyCode = getPartner().country.currency_code;

  // Get policy details
  const coverageType = policy.quotation && policy.quotation.additional_details
    ? policy.quotation.additional_details.cover_type
    : 'Member & Family';
  const primaryPlan = policy.quotation && policy.quotation.additional_details
    ? policy.quotation.additional_details.primary_plan
    : 'Unknown';

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{
        marginBottom: '30px',
        paddingBottom: '20px',
        borderBottom: '2px solid #e0e0e0'
      }}>
        <h1 style={{ fontSize: '26px', fontWeight: 'bold', marginBottom: '8px', color: '#032A37' }}>
          Confirm Member Details Update
        </h1>
        <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
          Review the changes before submitting
        </p>
      </div>

      {/* Policy Information */}
      <div style={{
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ marginBottom: '10px' }}>
              <span style={{ fontSize: '14px', color: '#666' }}>Policy:</span>
              <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#032A37', marginLeft: '10px' }}>
                {policy.policy_number}
              </span>
            </div>
            <div style={{ marginBottom: '10px' }}>
              <span style={{ fontSize: '14px', color: '#666' }}>Coverage:</span>
              <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#032A37', marginLeft: '10px' }}>
                {coverageType}
              </span>
            </div>
            <div>
              <span style={{ fontSize: '14px', color: '#666' }}>Plan:</span>
              <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#032A37', marginLeft: '10px' }}>
                {primaryPlan}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Member Information */}
      <div style={{
        backgroundColor: '#fff',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '15px', color: '#032A37' }}>
          Member Being Updated
        </h3>
        <div style={{ fontSize: '16px', color: '#032A37' }}>
          <strong>{member.first_name} {member.last_name}</strong> ({member.relationship})
        </div>
        <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
          Premium: {currencyCode} {((member.premium_amount_in_cents || 0) / 100).toFixed(2)}
        </div>
      </div>

      {/* Changes Table */}
      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '15px', color: '#032A37' }}>
          Changes Summary
        </h3>
        <table style={{
          width: '100%',
          background: '#FFFFFF',
          border: '1px solid #A7A7A7',
          borderCollapse: 'collapse'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #A7A7A7' }}>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7',
                textAlign: 'left'
              }}>
                Field
              </th>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7',
                textAlign: 'left'
              }}>
                Before
              </th>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7',
                textAlign: 'left'
              }}>
                After
              </th>
            </tr>
          </thead>
          <tbody>
            {changes.map((change, index) => (
              <tr key={index} style={{ borderTop: '1px solid #A7A7A7' }}>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  fontWeight: '600'
                }}>
                  {change.field}
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#666',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>
                  {change.before}
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#028a0f',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  fontWeight: '600'
                }}>
                  {change.after}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Premium Notice */}
      <div style={{
        backgroundColor: '#d4edda',
        border: '1px solid #28a745',
        borderRadius: '8px',
        padding: '15px',
        marginBottom: '30px',
        fontSize: '14px',
        color: '#155724'
      }}>
        <strong>Note:</strong> These changes will not affect the member's premium or benefits.
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
        <ButtonInc
          btnType="secondary"
          onClick={onBack}
          style={{ border: '1px solid #032A37' }}
        >
          Back
        </ButtonInc>
        <ButtonInc
          btnType="primary"
          onClick={onConfirm}
        >
          Confirm Changes
        </ButtonInc>
      </div>
    </div>
  );
};

export default SummaryScreen;
